export enum ScheduledReportType {
    UNKNOWN,
    LISTINGS_REPORT,
    DISTRIBUTION_TRACKING_REPORT,
    PREMIER_INN_REPORT,
}
